import { formatPhone } from 'commonUtils/formatters/formatPhone';
import { HIDE_DATA_SYMBOL } from 'constants/string';

export const getProtectedTitleWithUserData = (mobilePhone?: string, isHideData = false) => {
  if (!mobilePhone) return '';

  return isHideData ? formatPhone(HIDE_DATA_SYMBOL.repeat(10), false) : formatPhone(mobilePhone || '');
};
